import { shopometryTheme } from './shopometryTheme'

export const oneviuTheme = {
  // copy shopometryTheme styles
  ...shopometryTheme
}
